// Load all news article JSON files from src/content/news/
const newsContext = require.context('../../content/news', false, /\.json$/);

const newsArticles = newsContext.keys().map((key) => {
    const article = newsContext(key);
    // The file name (set by the CMS) is used as the URL slug: /nyheter/<slug>
    const slug = key.replace(/^.*\//, '').replace(/\.json$/, '');

    return {
        ...article,
        slug,
        // Articles with body text get their own page. Otherwise the link from the CMS is used.
        link: article.body ? `/nyheter/${slug}` : article.link,
    };
});

// Sort by date descending (newest first)
newsArticles.sort((a, b) => b.date.localeCompare(a.date));

// "2023.03.09" -> "2023-03-09"
export const toIsoDate = (date) => String(date).replace(/\./g, '-');

export default newsArticles;
